/**
 * Représente un fichier
 */

export class RemoteFile {
  type: string = ''
  file: string = ''
  path: string = ''
  basename: string = ''
  date: Date = new Date()
  size: number = 0
  extension: string = ''
  children: Array<RemoteFile> = []
}

export default RemoteFile
